module.exports = __webpack_public_path__ + "img/42.b71abed0.png";